import './OptionFilter.scss';

import { caseInsensitiveContainsFilterOption } from '@lib/filter';
import classNames from 'classnames';
import { LabeledValue } from 'antd/es/select';

import React, { memo, useCallback } from 'react';
import { Select, SelectProps } from 'antd';

export type OptionFilterValue = string | string[] | number | number[] | LabeledValue | LabeledValue[] | null;

export interface OptionFilterProps extends SelectProps<OptionFilterValue> {
	defaultValue?: Array<LabeledValue> | LabeledValue | string | null;
	onChange: (value: OptionFilterValue) => void;
	options: FilterOption[];
	showArrow?: boolean;
}

export type FilterOption = {
	label: string;
	value: string | number | null;
};

export const OptionFilter: React.FC<OptionFilterProps> = memo(
	({ className, defaultValue, filterOption, onChange, options, showArrow, ...rest }) => {
		// Select onChange passes a second argument that cannot be passed
		// When provided onChange is a setState function.
		const handleChange = useCallback(
			(value: OptionFilterValue) => onChange(value), [ onChange ]
		);

		const hasFilterOption = filterOption || typeof filterOption === 'boolean';

		return (
			<Select
				{ ...rest }
				allowClear
				className={ classNames('option-filter', className) }
				defaultValue={ defaultValue }
				filterOption={ hasFilterOption ? filterOption : caseInsensitiveContainsFilterOption }
				onChange={ handleChange }
				options={ options }
				showSearch
				suffixIcon={ showArrow ? undefined : null } />
		);
	}
);
